// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import PurchaseOrder from 'services/data/purchase-order';
import Person from 'services/data/person';

// Components
import PurchaseOrderForm from './forms/purchase-order-form';


class EditPurchaseOrder extends React.Component {
  static propTypes = {
    purchaseOrder: PropTypes.object.isRequired,
    cancel: PropTypes.func.isRequired,
    currentUser: PropTypes.object
  }

  constructor() {
    super();
    this.state = {};

    this.editPurchaseOrder = this.editPurchaseOrder.bind(this);
  }

  componentWillMount() {
    // Save the initial form values in the state on mount, because we don't want
    // to reinitialize the form if something about the PO changes while we're editing
    // it (like when it gets set to syncing while saving to the api)
    this.setState({ initialFormValues: getInitialFormValues(this.props.purchaseOrder) });
  }

  // Edit PO. We do not need to track whether the PO is syncing-- we use the form submitting
  // prop to know whether to display a loading indicator to the user
  editPurchaseOrder(values) {
    const formattedValues = _.cloneDeep(values);
    formattedValues.createdBy = formattedValues.purchasedBy;

    // Remove empty line items
    _.remove(formattedValues.lineItems, (lineItem) => _.every(lineItem, _.isEmpty));

    // Only save the status of archived line items so we don't allow people to delete required fields,
    // then archive the line item, then save, then get an error
    formattedValues.lineItems = _.map(formattedValues.lineItems, (lineItem) => {
      if (lineItem.status === 'Archived') return { id: lineItem.id, status: lineItem.status };
      return lineItem;
    });

    // Remove the empty object if the agreement isn't set
    if (!formattedValues.agreement || _.isEmpty(formattedValues.agreement)) {
      delete formattedValues.agreement;
    }

    // Use the agreement id instead of the agreement
    if (formattedValues.agreement && formattedValues.agreement.id) {
      formattedValues.agreement = formattedValues.agreement.id;
    }

    // Omit expenseBills and unbilledLineItems because sending these in can overwrite changes made to the PO line items.
    // Omit company because there is no company field on purchase orders, we just use this to find agreement
    return PurchaseOrder.update(_.omit(formattedValues, ['expenseBills', 'unbilledLineItems', 'company']))
      .then(() => PurchaseOrder.findOne(formattedValues.id, PurchaseOrder.defaultQuery))
      .then(this.props.purchaseOrder.update)
      .catch(alerts.catchError)
      .then(this.props.cancel);
  }

  render() {
    const { purchaseOrder, cancel, currentUser } = this.props;
    const isLead = Person.isLead(currentUser);
    const disableLineItems = !isLead && !_.isEmpty(purchaseOrder.expenseBills);

    return (
      <PurchaseOrderForm
        initialValues={this.state.initialFormValues}
        onSubmit={this.editPurchaseOrder}
        cancel={cancel}
        form={`purchaseOrderForm-${purchaseOrder.id}`}
        // Don't allow editing line items if there are any EBs for this PO
        disableLineItems={disableLineItems}
      />
    );
  }
}


function getInitialFormValues(purchaseOrder) {
  return {
    ..._.cloneDeep(purchaseOrder),
    company: purchaseOrder.company.id,
    ticket: (purchaseOrder.ticket || {}).id,
    purchasedBy: (purchaseOrder.createdBy || {}).id
  };
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(EditPurchaseOrder);
